import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    caption_small: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    caption_small?: React.CSSProperties;
  }
  interface Palette {
    neutral: {
      greyFont: string;
      greyBackground: string;
      dashBorder: string;
      otherBorder: string;
      lightBackground: string;
    };
    blue: {
      [900]: string;
      notego: string;
    };
    blueGrey: {
      [700]: string;
      [800]: string;
    };
  }
  interface PaletteOptions {
    neutral?: {
      greyFont?: string;
      greyBackground?: string;
      dashBorder?: string;
      otherBorder?: string;
      lightBackground?: string;
    };
    blue?: {
      [900]?: string;
      notego: string;
    };
    blueGrey: {
      [700]: string;
      [800]: string;
    };
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    caption_small: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2B9FFF',
      dark: '#2481CD',
      light: '#57B3FF',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00CDBC',
      dark: '#00B2A9',
      light: '#00D6C2',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D32F2F',
      dark: '#C62828',
      light: '#EF5350',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#EF6C00',
      dark: '#EF6C00',
      light: '#FF9800',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#2E7D32',
      dark: '#1B5E20',
      light: '#4CAF50',
      contrastText: '#FFFFFF',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    neutral: {
      greyFont: '#475569',
      greyBackground: '#AEAEAE',
      dashBorder: '#CBD5E1',
      otherBorder: '#E2E8F0',
      lightBackground: '#eef2ff',
    },
    blue: {
      900: '#0D47A1',
      notego: '#001C53',
    },
    blueGrey: {
      700: '#455A64',
      800: '#37474F',
    },
  },
  typography: {
    allVariants: {
      fontFamily: 'Inter',
    },
    caption_small: {
      fontSize: '10px',
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: '0.4px',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          overflowX: 'hidden',
        },
        html: {
          overflowX: 'hidden',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '100px',
          boxShadow: 'none',
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        placement: 'top',
        arrow: true,
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: 'rgba(15, 23, 42, 0.9)',
          backdropFilter: 'blur(8px)',
          borderRadius: '8px',
          fontSize: '0.75rem',
          fontWeight: 500,
          padding: '6px 10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        },
        arrow: {
          color: 'rgba(15, 23, 42, 0.9)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9CA3AF',
            borderWidth: '1.5px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#6B7280',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2B9FFF',
            borderWidth: '2px',
          },
        },
        input: {
          '&::placeholder': {
            color: '#6B7280',
            opacity: 1,
          },
        },
      },
    },
  },
});

export default theme;
